import { ITooltipProperties } from '@vfde-brix/ws10/tooltip';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { TooltipConfig } from '../../interface';

/**
 * Get properties from CMS config for tooltip
 *
 * @param cmsConfig - CMS Tooltip config
 */
export const getTooltipProps = (cmsConfig: TooltipConfig): ITooltipProperties => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdTooltipId: cmsConfig.id,
    stdHeadline: cmsConfig.headline,
    txtContent: cmsConfig.text,
});
